module.exports = __webpack_public_path__ + "img/03_slip_rubber.0639392f.png";